import { render, staticRenderFns } from "./ChooseLang.vue?vue&type=template&id=67ec9258&scoped=true"
import script from "./ChooseLang.vue?vue&type=script&lang=js"
export * from "./ChooseLang.vue?vue&type=script&lang=js"
import style0 from "./ChooseLang.vue?vue&type=style&index=0&id=67ec9258&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ec9258",
  null
  
)

export default component.exports